import currency from "currency.js";
import { Table } from "react-bootstrap";

// Extracted SelectedItemsTable component
export function SelectedItemsTable({
  filteredItemDetails,
  selectedData,
  onSelectedOnly,
  selectAllOnly,
  vendorRFQ,
  isSelected,
}) {
  return (
    <div className="mx-3">
      <Table responsive borderless striped className="product-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={selectAllOnly}
                checked={
                  selectedData.length > 0 &&
                  selectedData.length === vendorRFQ.length
                }
                disabled={isSelected}
              />
            </th>
            <th>Vendor</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>Unit Cost</th>
            <th>Quantity</th>
            <th>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {filteredItemDetails.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  onChange={() => onSelectedOnly(item)}
                  checked={selectedData.some(
                    (selected) => selected.id === item.id,
                  )}
                  disabled={isSelected}
                />
              </td>
              <td>{item?.VendorsRFQs?.CompanyName}</td>
              <td>{item.barcode}</td>
              <td>{item.itemName}</td>
              <td>{item.amount}</td>
              <td>{item.quantity}</td>
              <td>
                {!isNaN(item.amount * item.quantity)
                  ? currency(item.amount, {
                      precision: 2,
                      symbol: " ",
                    })
                      .multiply(item.quantity)
                      .format()
                  : 0}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {filteredItemDetails.length > 0 && (
        <div className="d-flex justify-content-end mb-3">
          <div className="gridChild gridChildBorderLeftBlue">
            <div className="gridChildLeft">
              <p className="gridChld1">
                {currency(
                  filteredItemDetails.reduce(
                    (sum, item) => sum + item.amount * item.quantity,
                    0,
                  ),
                  {
                    symbol: "",
                  },
                ).format()}
              </p>
              <p className="gridChld2">Total</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
